import IconActivity from './activity_icon.png';
import IconCalorie from './calorie_icon.png';
import IconGreen from './green_icon.png';
import IconRed from './red_icon.png';
import IconWeight from './weight_icon.png';
import IconBeans from '../../../../images/graphic.png';
import IconFamily from 'cccisd-icons/users4';
import IconStar from 'cccisd-icons/star';
import IconCheck from 'cccisd-icons/checkmark-circle';

export default {
    IconActivity,
    IconCalorie,
    IconGreen,
    IconRed,
    IconWeight,
    IconBeans,
    IconFamily,
    IconStar,
    IconCheck,
};
